/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';

/**
 * Definición de estilos personalizados para el tema de PrimeNG
 */
export const SuraPreset = definePreset(Material, {
  primitive: {
    blue: {
      50: '#dfeaff',
      100: '#e5e9ea',
      200: '#81b1ff',
      300: '#93c5fd',
      400: '#8a9cd3',
      500: '#2d6df6',
      600: '#2563eb',
      700: '#1d4ed8',
      800: '#0033a0',
      900: '#1e3a8a',
      950: '#172554'
    }
  },
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  },
  components: {
    confirmdialog: {
      icon: {
        size: '2rem'
      }
    },
    tooltip: {
      max: {
        width: '350px'
      },
      background: 'white',
      color: '#374151'
    },
    datatable: {
      body: {
        cell: {
          padding: '0.5rem 1rem'
        }
      }
    },
    tabs: {
      tabpanel: {
        padding: '1.25rem 1.25rem 1.25rem 0rem'
      }
    },
    inputtext: {
      border: {
        radius: '12px'
      },
      padding: {
        x: '18px',
        y: '0.625rem'
      },
      focus: {
        border: {
          color: '{blue.500}'
        }
      }
    },
    dropdown: {
      border: {
        radius: '12px'
      }
    },
    calendar: {
      border: {
        radius: '12px'
      }
    },
    datepicker: {
      border: {
        radius: '12px'
      },
      panel: {
        border: {
          radius: '12px'
        },
        shadow: '0 4px 16px rgba(0, 0, 0, 0.1)'
      },
      day: {
        border: {
          radius: '50%'
        },
        selected: {
          background: '{blue.500}',
          color: '#ffffff'
        }
      },
      month: {
        selected: {
          background: '{blue.500}',
          color: '#ffffff'
        }
      },
      year: {
        selected: {
          background: '{blue.500}',
          color: '#ffffff'
        }
      },
      header: {
        color: '{blue.800}'
      },
      today: {
        border: {
          color: '{blue.500}'
        }
      }
    },
    inputnumber: {
      border: {
        radius: '12px'
      }
    },
    card: {
      border: {
        radius: '12px'
      }
    },
    floatlabel: {
      focus: {
        color: '{blue.800}'
      },
      active: {
        color: '{blue.800}'
      }
    },
    button: {
      border: {
        radius: '50px'
      },
      primary: {
        background: '{blue.500}',
        hover: {
          background: '{blue.800}'
        },
        active: {
          background: '{blue.900}'
        }
      },
      warn: {
        background: '#e3e829',
        color: '{blue.800}'
      }
    }
  }
});
